<template>
  <div class="col-12">
    <div class="row b-form__row_type_flex">
      <div class="col-3">
        <label>{{$t('CONTENT.currency.currencyRate_type')}}:</label>
        <cool-select
          :list="allCurrencyCodeTypes"
          option-value="value"
          option-text="name"
          :placeholder="$t('CONTENT.choose')"
          :isError="isFieldWithError('currencyCodeType', selectedCurrencyCodeType)"
          v-model="selectedCurrencyCodeType"
        ></cool-select>
      </div>
      <div class="col-3" v-if="selectedCurrencyCodeType === 'Imported'" :key="'Imported'">
        <label>{{ $t('CONTENT.currency.currencyRate_imported_name') }}:</label>
        <cool-select
          :list="importedCourseNames"
          option-value="value"
          option-text="name"
          v-model="selectedImportedId"
          :placeholder="$t('CONTENT.choose')"
        ></cool-select>
      </div>
      <div class="col-4" v-if="selectedCurrencyCodeType === 'CBR' || (selectedCurrencyCodeType === 'Imported' && selectedImportedId)" :key="'CBR'">
        <label>{{$t('CONTENT.currency.currencyRate_course')}}:</label>
        <div>{{currentRateResult}}</div>
      </div>
      <div class="col-9" v-if="selectedCurrencyCodeType === 'Corridor' || selectedCurrencyCodeType === 'Corridor_Imported'" :key="'Corridor'">
        <div class="row b-form__row_type_flex">
          <div class="col-4">
            <label>min:</label>
            <numeric
              class="b-numeric"
              controls
              :min="minValueForCurrencyRateMin"
              :max="maxValueForCurrencyRateMin"
              v-model="selectedCurrencyRateMin"
            ></numeric>
          </div>
          <div class="col-4">
            <label>max:</label>
            <numeric
              class="b-numeric"
              controls
              :min="minValueForCurrencyRateMax"
              :max="maxValueForCurrencyRateMax"
              v-model="selectedCurrencyRateMax"
            ></numeric>
          </div>
          <div class="col-4">
            <label>{{$t('CONTENT.currency.currencyRate_course')}}:</label>
            <div>{{currentRateResult}}</div>
          </div>
        </div>
      </div>
      <div class="col-4" v-if="selectedCurrencyCodeType === 'Fixed'" :key="'Fixed'">
        <label>{{$t('CONTENT.currency.currencyRate_course')}}:</label>
        <numeric
          class="b-numeric"
          controls
          :min="0"
          :max="1000000000000"
          v-model="selectedCurrencyRateFixedValue"
        ></numeric>
      </div>
    </div>
    <PercentAndPeriodRateWidgetWithoutStore
      v-if="selectedCurrencyCodeType === 'CBR'"
      :payment="payment"
    ></PercentAndPeriodRateWidgetWithoutStore>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dateConverter from "@/utils/converters/date.converter";
import PercentAndPeriodRateWidgetWithoutStore from '@/plugins/assetComponent/components/PercentAndPeriodRateWidgetWithoutStore';
import CurrencyRate from "../../../../api/CurrencyRate";

export default {
  components: {
    PercentAndPeriodRateWidgetWithoutStore,
  },
  props: {
    currencyCode: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    currencyRateParameters: {
      type: Object,
    },
    validationErrors: {
      type: Array,
    },
    payment: {
      type: Object,
      required: true,
    },
    assetStartDate: {
      type: String,
      default: null,
    },
    assetEndDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentRateResult: null,
      minValueForCurrencyRateMin: 0,
      maxValueForCurrencyRateMin: 10000,
      minValueForCurrencyRateMax: 0,
      maxValueForCurrencyRateMax: 10000,
      allCurrencyCodeTypes: [
        { name: this.$t("CONTENT.currency.currencyRate_CBR"), value: "CBR" },
        { name: this.$t("CONTENT.currency.currencyRate_corridor"), value: "Corridor" },
        { name: this.$t("CONTENT.currency.currencyRate_fix"), value: "Fixed" },
        { name: this.$t("CONTENT.currency.currencyRate_imported"), value: "Imported" },
      ],
      selectedCurrencyCodeType: null,
      selectedCurrencyRateFixedValue: null,
      selectedCurrencyRateMin: null,
      selectedCurrencyRateMax: null,
      importedCourseNames: [],
      selectedImportedId: null,
    };
  },
  computed: {
    ...mapGetters(['getContractSettings']),
  },
  created() {
    if(this.currencyRateParameters) {
      if(this.currencyRateParameters.type !== null) {
        this.selectedCurrencyCodeType = this.currencyRateParameters.type;
      }

      if(this.currencyRateParameters.minValue !== null) {
        this.selectedCurrencyRateMin = this.currencyRateParameters.minValue;
      }

      if(this.currencyRateParameters.maxValue !== null) {
        this.selectedCurrencyRateMax = this.currencyRateParameters.maxValue;
      }

      if(this.currencyRateParameters.fixedValue !== null) {
        this.selectedCurrencyRateFixedValue = this.currencyRateParameters.fixedValue;
      }

      if(this.currencyRateParameters.importedId !== null) {
        this.selectedImportedId = this.currencyRateParameters.importedId;
      }
    }
    this.getImportedCourseNames();
  },
  watch: {
    selectedImportedId() {
      this.getCurrentRate();
    },
    currencyCode() {
      this.selectedCurrencyCodeType = 'CBR';
      this.getCurrentRate();
    },
    selectedCurrencyCodeType(val) {
      if (val === "CBR" || val === "Imported") {
        this.getCurrentRate();
      }
      if (
        (val === "Corridor" || val === "Corridor_Imported") &&
        this.selectedCurrencyRateMin !== null &&
        this.selectedCurrencyRateMax !== null
      ) {
        this.getCurrentRate();
      }
      if (val === "Fixed" && this.selectedCurrencyRateFixedValue !== null) {
        this.getCurrentRate();
      }
    },
    selectedCurrencyRateMax(val, oldVal) {
      if (oldVal !== val) {
        this.getCurrentRate();
      }
    },
    selectedCurrencyRateMin(val, oldVal) {
      if (oldVal !== val) {
        this.getCurrentRate();
      }
    },
    selectedCurrencyRateFixedValue(val, oldVal) {
      if (oldVal !== val) {
        this.getCurrentRate();
      }
    }
  },
  methods: {
    async getImportedCourseNames() {
      const api = new CurrencyRate();
      api.getImportedCourseNames()
        .then((data) => {
          this.importedCourseNames = data.map(elem => ({ name: elem.fileName, value: elem.fileId }));
        });
    },
    async getCurrentRate() {
      if (
        (this.selectedCurrencyCodeType === "Corridor" || this.selectedCurrencyCodeType === "Corridor_Imported") &&
        (this.selectedCurrencyRateMax == null ||
          this.selectedCurrencyRateMin == null)
      ) {
        this.currentRateResult = `${this.$t('CONTENT.fill_all_fields')}`;
        return;
      }
      if (
        this.selectedCurrencyCodeType === "Fixed" &&
        this.selectedCurrencyRateFixedValue == null
      ) {
        this.currentRateResult = `${this.$t('CONTENT.fill_all_fields')}`;
        return;
      }
      if (
        this.selectedCurrencyCodeType === 'Imported' && !this.selectedImportedId) {
        return;
      }

      let currentRate = null;

      let encodedStartDate = encodeURIComponent(this.date);
      this.currentRateResult = null;

      const currencyRateData = {
        onDate: encodedStartDate,
        type: this.selectedCurrencyCodeType,
        currencyCode: this.currencyCode.toUpperCase(),
        minValue: this.selectedCurrencyRateMin,
        maxValue: this.selectedCurrencyRateMax,
        fixedValue: this.selectedCurrencyRateFixedValue,
        importedId: this.selectedImportedId,
      };

      try {
        currentRate = await this.$store.dispatch(
          "getCurrencyRate",
          currencyRateData
        );

        this.setCurrentRateResult(currentRate);
        this.$emit("currencyRateDataChange", currencyRateData);
      } catch (e) {
        this.currentRateResult = `${this.$t('CONTENT.no_data')}`;
      }
    },
    setCurrentRateResult(currentRate) {
      const dateObject = dateConverter.convertToDate(this.date);
      this.currentRateResult = `${currentRate.value} (${
        currentRate.currencyCode
      }) на ${this.$d(dateObject)}`;
    },
    isFieldWithError(field, value) {
      return !value && this.validationErrors && this.validationErrors.includes(field);
    }
  }
};
</script>
